import styled from '@emotion/styled';
import theme from '@ep/theme';

const SubNavItemLabel = styled.div`
  font-family: ${theme.typography.boldFont};
  font-size: ${theme.typography.toRem(16)};
  font-weight: bold;
  text-transform: uppercase;
  text-align: initial;
  letter-spacing: 1px;
  cursor: pointer;
  :hover {
    color: ${theme.colors.mediumBlue};
    text-decoration: none;
  }
`;

export default SubNavItemLabel;
